import React from 'react';
import { motion } from 'framer-motion';
import { Clock, CheckCircle2, Heart, Gift } from 'lucide-react';
import { Section } from './ui/Section';
const benefits = [{
  icon: Clock,
  title: '15 minutos al día',
  description: 'Olvídate de las maratones de limpieza los fines de semana.'
}, {
  icon: CheckCircle2,
  title: 'Resultados desde el día 1',
  description: 'Verás la diferencia inmediatamente en tus superficies.'
}, {
  icon: Heart,
  title: 'Sin agotamiento',
  description: 'Funciona con niños, mascotas y el caos de la vida real.'
}, {
  icon: Gift,
  title: 'Regalo Ideal',
  description: 'Perfecto como regalo digital de Navidad para ti misma.'
}];
export function BenefitsSection() {
  return <Section background="white" className="border-b border-gray-100" data-id="element-1">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-2">
        {benefits.map((benefit, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1,
        duration: 0.5
      }} className="flex flex-col items-center text-center p-6 rounded-2xl hover:bg-[#FFF9F5] transition-colors duration-300" data-id="element-3">
            <div className="w-12 h-12 bg-[#FFF9F5] rounded-full flex items-center justify-center mb-4 text-[#FF6B6B]" data-id="element-4">
              <benefit.icon className="w-6 h-6" data-id="element-5" />
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-6">
              {benefit.title}
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-7">
              {benefit.description}
            </p>
          </motion.div>)}
      </div>
    </Section>;
}